// src/components/routes/ProtectedCompanyRoute.js
import React from 'react';
import { Navigate, Outlet, Route, useLocation } from 'react-router-dom';


import { useAuth } from '../../hooks/useAuth';
import { useActiveCompany } from '../../contexts/ActiveCompanyContext';


const ProtectedCompanyRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const { activeCompanyId } = useActiveCompany();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-dark-900">
        <div className="w-16 h-16 border-4 border-primary-200 border-t-primary-500 rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location, message: "Debes iniciar sesión para acceder." }} replace />;
  }

  // Aceptar dos casos:
  //  - legacy: user.user_type === 'company' (el auth user ES la empresa)
  //  - Fase 2: técnico con un activeCompanyId distinto (administra empresa creada con owner_id)
  const hasAccess = user.user_type === 'company'
    || (activeCompanyId && activeCompanyId !== user.id);

  if (!hasAccess) {
    return <Navigate
      to="/"
      state={{ message: "Solo las cuentas empresariales pueden acceder a esta sección." }}
      replace
    />;
  }

  return children;
};

export default ProtectedCompanyRoute;